import { render, staticRenderFns } from "./LogoPlaceholder.vue?vue&type=template&id=56b290a8"
import script from "./LogoPlaceholder.vue?vue&type=script&lang=js"
export * from "./LogoPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports